
    <div fxLayout="row" fxLayoutAlign="center">
        <div fxFlex="60">
            <app-match-list></app-match-list>
        </div>
        <div fxFlex>
            <router-outlet></router-outlet>
        </div>
    </div>
